/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Birthday_Others_OneInputs */

const fr_calendar_birthday_others_one = /** @type {(inputs: Calendar_Birthday_Others_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`et 1 autre`)
};

/**

* @param {Calendar_Birthday_Others_OneInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_birthday_others_one = /** @type {((inputs?: Calendar_Birthday_Others_OneInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Birthday_Others_OneInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_birthday_others_one(inputs)
});